import { useTranslation } from 'react-i18next';
import { StyleSheet, View } from 'react-native';
import { Text } from 'react-native-paper';
import { useAutoFocusRef } from '../../hooks/useAutoFocusRef';
import { Colors } from '../../themes/colors';
import { tokens } from '../crop-circle/tokens';
import { ControlledPhoneInput } from '../forms/controlledPhoneInput';
import { ControlledTextInput } from '../forms/controlledTextInput';

export type EditProfileFormProps = {
  control: any;
  inputMaxWidth?: number;
  autoFocus?: boolean;
  inputBackgroundColor?: string;
  useCropCircle?: boolean;
};

export const EditProfileForm = (props: EditProfileFormProps) => {
  const { t } = useTranslation();
  const elementFocusCallBack = useAutoFocusRef();

  return (
    <View style={styles.saveForm}>
      <View style={[styles.formItem, { maxWidth: props.inputMaxWidth }]}>
        <View>
          <Text variant={'titleMedium'} style={styles.formItemTitle}>
            {t('firstName')}
          </Text>
        </View>
        <ControlledTextInput
          control={props.control}
          name="firstName"
          placeholder={t('firstName')}
          innerRef={props.autoFocus ? elementFocusCallBack : undefined}
          autoComplete="given-name"
          useCropCircle={props.useCropCircle}
          hideBorder={props.useCropCircle}
          height={props.useCropCircle ? 48 : undefined}
          backgroundColor={
            props.useCropCircle
              ? props.inputBackgroundColor ?? Colors.primaryGrayBackground
              : props.inputBackgroundColor
          }
        />
      </View>
      <View style={[styles.formItem, { maxWidth: props.inputMaxWidth }]}>
        <View>
          <Text variant={'titleMedium'} style={styles.formItemTitle}>
            {t('lastName')}
          </Text>
        </View>
        <ControlledTextInput
          control={props.control}
          name="lastName"
          placeholder={t('lastName')}
          autoComplete="family-name"
          useCropCircle={props.useCropCircle}
          hideBorder={props.useCropCircle}
          height={props.useCropCircle ? 48 : undefined}
          backgroundColor={
            props.useCropCircle
              ? props.inputBackgroundColor ?? Colors.primaryGrayBackground
              : props.inputBackgroundColor
          }
        />
      </View>
      <View style={[styles.formItem, { maxWidth: props.inputMaxWidth }]}>
        <View>
          <Text variant={'titleMedium'} style={styles.formItemTitle}>
            {t('email')}
          </Text>
        </View>
        <ControlledTextInput
          control={props.control}
          name="email"
          placeholder={t('email')}
          keyboardType="email-address"
          isLowerCase
          useCropCircle={props.useCropCircle}
          hideBorder={props.useCropCircle}
          height={props.useCropCircle ? 48 : undefined}
          backgroundColor={
            props.useCropCircle
              ? props.inputBackgroundColor ?? Colors.primaryGrayBackground
              : props.inputBackgroundColor
          }
        />
      </View>
      <View style={[styles.formItem, { maxWidth: props.inputMaxWidth }]}>
        <View>
          <Text variant={'titleMedium'} style={styles.formItemTitle}>
            {'Phone'}
          </Text>
        </View>
        <ControlledPhoneInput
          control={props.control}
          name="phone"
          placeholder={'phone'}
          backgroundColor={
            props.useCropCircle
              ? props.inputBackgroundColor ?? Colors.primaryGrayBackground
              : props.inputBackgroundColor
          }
          borderRadius={props.useCropCircle ? 4 : undefined}
        />
      </View>
      <View style={[styles.formItem, { maxWidth: props.inputMaxWidth }]}>
        <View>
          <Text variant={'titleMedium'} style={styles.formItemTitle}>
            {t('jobTitle')}
          </Text>
        </View>
        <ControlledTextInput
          control={props.control}
          name="jobTitle"
          placeholder={t('jobTitle')}
          useCropCircle={props.useCropCircle}
          hideBorder={props.useCropCircle}
          height={props.useCropCircle ? 48 : undefined}
          backgroundColor={
            props.useCropCircle
              ? props.inputBackgroundColor ?? Colors.primaryGrayBackground
              : props.inputBackgroundColor
          }
        />
      </View>
    </View>
  );
};
const styles = StyleSheet.create({
  saveForm: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    paddingBottom: tokens.spacing['2xl'],
  },

  formItem: {
    marginTop: tokens.spacing.lg,
    width: '100%',
  },
  formItemTitle: {
    ...tokens.typography.body.mediumEmphasised,
    color: tokens.colors.neutral[800],
    marginBottom: tokens.spacing.sm,
  },
});
